import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import {AppDataService} from "../../../../services/app-data.service";
import { CompanyService }  from '../../../../services/company.service';

declare let $: any;
declare let Swal: any;

@Component({
    selector : 'seminar-questions',
    templateUrl:'seminar-questions-component.html'
})
export class SeminarQuestionsComponent implements OnInit, OnDestroy{
  public questions=[];
  public questionsReference;
  public makeQuestion=false;

  public constructor( private _router : Router,public _appData : AppDataService,private _companyService : CompanyService) {
  }
  public makeAQuestion(){
    Swal.fire({
      title: 'Escreva sua dúvida para o palestrante',
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
      confirmButtonText: 'PERGUNTAR',
      cancelButtonText: 'CANCELAR',
      showLoaderOnConfirm: true,
    }).then((result) => {
      if (result.value) {
        this.newQuestion(result.value);
      }
    })
  }
  public seeQuestion(question){
    let obj=null;
    //check if admin
    let admin=false;
    if (this._appData.event.admins) {
      let user=this._appData.event.admins.filter((val=>{
        this._appData.instagramUser.uid==val;
      }));
      if (user) admin=true;
    }
    if (admin){
      obj={
        title: 'Dúvida de '+question.user.name,
        text: question.text,
        confirmButtonText: 'FECHAR',
      }

    }
    else{
      obj={
        title: 'Dúvida de '+question.user.name,
        text: question.text,
        showCancelButton: true,
        confirmButtonText: 'RESPONDER',
        cancelButtonText: 'FECHAR',
        showLoaderOnConfirm: true,
      }
    }
    Swal.fire(obj).then((result) => {
      if (result.value) {
        //this.newQuestion(result.value);
      }
    })
  }

  public ngOnInit(): any {
    this.questionsReference=this._companyService.getEventQuestions(this._appData.event).on("child_added", (snapshot, prevChildKey) =>{     
      let date=new Date();
      let mymessages=this.questions;
      if (!mymessages) mymessages=[];
      let _messages=snapshot.val();
      let milis=date.getTime()-10*60*1000;//last 10 minutes
      //normal messages
      this.questions.push(_messages)
      setTimeout(function(){ 
        var objDiv2 = $("#mobileQuestions");
        objDiv2.animate({
          scrollTop: objDiv2[0].scrollHeight
        }, 'fast');
      }, 100);
              
    });

  }


  
  public newQuestion(message) {
    if($.trim(message) == '') {
      return false;
    }
    let id=new Date();
    let msgObj={
      _id: id.getTime(),
      createdAt: id.getTime(),
      text:message,
      user:{
        _id: this._appData.instagramUser.uid,
        avatar: this._appData.instagramUser.profile_picture,
        name: this._appData.instagramUser.full_name
      }
    }
    this._companyService.addEventQuestions(this._appData.event,msgObj).then((data)=>{
      this.makeQuestion=false;

    }).catch((error)=>{
        console.log('error')
        console.log(error)
      })       
  }
  public openScreen(screen){
    this._appData.cellScreen=screen;
  }

  public ngOnDestroy() : any {
    this.questionsReference.off();

  }
}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/cellphone-modal/seminar-questions/seminar-questions-component.ts